// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__32vmu","header":"ReportDetails_header__2S6f_","title":"ReportDetails_title__2Y2i2","left":"ReportDetails_left__3uOE_"};